// Modo manutenção: liga com VITE_MAINTENANCE_MODE=true (.env.production) e
// exige novo build. Mostra a faixa de aviso no topo (MaintenanceBanner) e faz
// os CTAs de cadastro abrirem o aviso em vez do formulário (useSignupModal).
// O retorno do checkout (?signup=success) não passa por aqui — quem já pagou
// conclui o cadastro normalmente.
//
// O app dos clientes usa a mesma API, então durante a manutenção o acesso de
// quem já é cliente também fica indisponível — os textos dizem isso.
export const maintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true'

export const maintenanceMessage = {
  title: 'Estamos em manutenção',
  banner: 'Não é possível acessar a plataforma nem fazer novos cadastros no momento.',
  text: 'Estamos melhorando a plataforma. Durante a manutenção, não é possível acessar a plataforma nem fazer novos cadastros. Voltamos em breve.',
}
